import angular from 'angular'

// components
import manageGlobalOptionGroup from './component/manageGlobalOptionGroup.component'

export default angular
  .module('portalApp.manage.globalOptionGroup', [])
  .component('manageGlobalOptionGroup', manageGlobalOptionGroup)
  .name
